import { toOptions } from './ArrayUtil';

export const hearingAidAboutData = ['人工内耳装用', '補聴器装用'];
export const hearingAidAboutDataOptions = toOptions(hearingAidAboutData);

export const hearingAidData = ['ほとんど聞こえている', '聞こえているときが多い', '聞こえていないときが多い', '音は分かるが内容が分からない', 'ほとんど聞こえていない', '分からない'];
export const hearingAidDataOptions = toOptions(hearingAidData);
